import React from 'react'

const CustomDeletePopup = ({ deleteHandler, message }) => {
    return (
        <div className="background-blur-external" style={{ zIndex: '9999' }}>
            <div className='delete-popup-main'>
                <p className='text'>{message}</p>
                <hr />
                <div className="text-end">
                    <button type="button" className="cred-btn" onClick={e => deleteHandler('yes')}>Yes</button>
                    <button type="button" className="cred-btn cancel-btn" onClick={e => deleteHandler('no')}>No</button>
                </div>
            </div>
        </div>
    )
}

export default CustomDeletePopup;